export default __webpack_public_path__ + "static/media/errordog.5880a2c3.svg";